module.exports = __webpack_public_path__ + "img/arrow-right.b0ca0b3b.png";